
import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { Component } from 'react';
import { ButtonCallToAction, ButtonTertiary } from 'ui';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import styles from './risk-matrix-sticky-header.scss';
import { consequencesAndLostPotentialCodetableId, RiskMatrixTranslation } from 'app/area/risk-matrix-administration/constants';
import { RiskMatrixAxes, RiskMatrixAxis } from 'app/area/risk-matrix-administration/types-store';
import { SupportedListScreens } from 'app/area/codetable/list/list-renderer/supported-screens';
import { RiskMatrixMeatball } from 'app/area/risk-matrix-administration/components/sticky-header/risk-matrix-meatball';

export interface CodetableStickyHeaderProps {
  breadcrumbs: JSX.Element;
  translation: RiskMatrixTranslation;
  save: () => void;
  cancel: () => void;
  readOnly: boolean;
  disabled: boolean;
  axes: RiskMatrixAxes;
}

export class RiskMatrixStickyHeader extends Component<CodetableStickyHeaderProps> {

  public render() {
    const {
      translation, breadcrumbs, save, cancel, readOnly, disabled, axes = []
    } = this.props;

    const meatballItems = [riskArea(), ...axes];

    const navigateToAxisCodetableHandlers = meatballItems?.map(axis =>
      () => navigate.toCodeListWithBreadcrumbs([consequencesAndLostPotentialCodetableId, axis?.codetableId]));

    return (
      <StickyHeader className={styles.stickyHeader} rightSideContent={<>
        <StickyHeaderButtonContainer>
          <div className={styles.buttonContainer}>
            {
              readOnly ? null : <>
                {disabled ? null : <ButtonTertiary id="risk-matrix-sticky-header-cancel-button-" onClick={cancel} disabled={false}>
                  {translation.cancel_changes}
                </ButtonTertiary>}
                <ButtonCallToAction
                  id="risk-matrix-sticky-header-save-button"
                  onClick={save}
                  disabled={disabled}>
                  {translation.update_risk_matrix}
                </ButtonCallToAction>
                <div className={styles.largeScreenMeatball}>
                  <RiskMatrixMeatball
                    items={meatballItems}
                    onClick={navigateToAxisCodetableHandlers}
                    translation={translation}
                  />
                </div>
              </>
            }
          </div>
        </StickyHeaderButtonContainer>
      </>
      } classNames={{ leftSideContent: styles.leftSideContent }}>
        <div className={styles.breadcrumbs}>
          {breadcrumbs}
        </div>
        <div className={styles.mobileMeatball}>
          <RiskMatrixMeatball
            items={meatballItems}
            onClick={navigateToAxisCodetableHandlers}
            translation={translation}
          />
        </div>
      </StickyHeader>
    );
  }
}

const riskArea = (): RiskMatrixAxis => ({
  codetableId: SupportedListScreens.RiskArea,
  items: [],
  sortOrderType: undefined
});
